__turbopack_context__.v({
  "cardContent": "Equaldex-module__dkNFMq__cardContent",
  "contentSection": "Equaldex-module__dkNFMq__contentSection",
  "imagePlaceholder": "Equaldex-module__dkNFMq__imagePlaceholder",
  "imageSection": "Equaldex-module__dkNFMq__imageSection",
});
